import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import pixelEvent from "../../../hooks/pixelEvent";
import gaEvents from "../../../hooks/gaEvents";

import style from "./LicenseProductsList.module.sass";
import iconDownload from "../../../assets/images/icons/icon_download.svg";
import LicenseInfo from "../LicenseInfo/LicenseInfo";

/* eslint-disable prefer-destructuring, camelcase */
function LicenseProductsList({ provider }) {
  const onInstall = (id, itemName, urlInstall) => {
    gaEvents.installProduct(itemName, urlInstall);
    pixelEvent({
      evt_src: "acct",
      evt_action: "click_install",
      id,
      item_name: itemName,
    });
  };
  return (
    <>
      {provider.products &&
        provider.products.map((product, index) => {
          return (
            <div key={index} className={style.licenseProduct}>
              <img
                src={product.product_img}
                className={style.productImg}
                alt=""
              />
              <div className={style.information}>
                <div className={style.productName}>
                  {product.name_prod} {product.license_name}
                </div>
                {product.licenses
                  .sort((a, b) => {
                    return b.license_expire_time - a.license_expire_time;
                  })
                  .map((license, i) => {
                    const { license_expire_time, moneyBackIcon, created_time } =
                      license;
                    return (
                      <LicenseInfo
                        key={i}
                        licenseExpireTime={license_expire_time}
                        product={product}
                        license={license}
                        moneyBackIcon={moneyBackIcon}
                        createdTime={created_time}
                      />
                    );
                  })}
                <div className={style.installProductBlock}>
                  <div className={style.company}>{provider.product}</div>
                  <a
                    className={style.install}
                    style={{
                      background: `url(${iconDownload}) left top no-repeat`,
                    }}
                    href={product.url_install}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() =>
                      onInstall(
                        provider.id,
                        product.item_name,
                        product.url_install
                      )
                    }
                  >
                    Install
                  </a>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
}

LicenseProductsList.propTypes = {
  provider: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array])
  ),
};
LicenseProductsList.defaultProps = {
  provider: null,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LicenseProductsList);
